import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_GoodsReceiptProcessPosition } from "./SIV_GoodsReceiptProcessPosition";
import type { SIV_GoodsReceiving } from "./SIV_GoodsReceiving";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_GoodsReceivingItemAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  amount?: number | undefined;
  changedAt?: Date | undefined;
  changedBy?: _User | undefined;
  description?: string | undefined;
  filler?: string | undefined;
  goodsReceiptProcessPosition?: SIV_GoodsReceiptProcessPosition | undefined;
  goodsReceiving: SIV_GoodsReceiving;
  itemNo: string;
  notFoundValues: any;
  tenant?: OD3_Tenant | undefined;
}

export class SIV_GoodsReceivingItem extends Parse.Object<SIV_GoodsReceivingItemAttributes> {
  static className: string = "SIV_GoodsReceivingItem";

  constructor(data?: Partial<SIV_GoodsReceivingItemAttributes>) {
    super("SIV_GoodsReceivingItem", data as SIV_GoodsReceivingItemAttributes);
  }

  get amount(): number | undefined {
    return super.get("amount");
  }
  set amount(value: number | undefined) {
    super.set("amount", value);
  }

  get changedAt(): Date | undefined {
    return super.get("changedAt");
  }
  set changedAt(value: Date | undefined) {
    super.set("changedAt", value);
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }

  get filler(): string | undefined {
    return super.get("filler");
  }
  set filler(value: string | undefined) {
    super.set("filler", value);
  }

  get goodsReceiptProcessPosition():
    | SIV_GoodsReceiptProcessPosition
    | undefined {
    return super.get("goodsReceiptProcessPosition");
  }
  set goodsReceiptProcessPosition(
    value: SIV_GoodsReceiptProcessPosition | undefined,
  ) {
    super.set("goodsReceiptProcessPosition", value);
  }

  get goodsReceiving(): SIV_GoodsReceiving {
    return super.get("goodsReceiving");
  }
  set goodsReceiving(value: SIV_GoodsReceiving) {
    super.set("goodsReceiving", value);
  }

  get itemNo(): string {
    return super.get("itemNo");
  }
  set itemNo(value: string) {
    super.set("itemNo", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("SIV_GoodsReceivingItem", SIV_GoodsReceivingItem);
